module.exports = __webpack_public_path__ + "static/media/fullService.04de7ec1.png";